import Box from "@mui/material/Box";
import React from "react";

import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import { AccessoryNoteCard } from "./AccessoriesCards";
import { roofKey } from "./BoxStructureCards";

const AccessoriesLocks = () => (
  <>
    <StructureSection titleKey={roofKey("SECTIONS.LOCKS")}>
      <CardRow columns={3}>
        <AccessoryNoteCard
          cardKey="dieselLock"
          titleKey={roofKey("CARDS.DIESEL_LOCK")}
        />
        <AccessoryNoteCard
          cardKey="ureaLock"
          titleKey={roofKey("CARDS.UREA_LOCK")}
        />
        <AccessoryNoteCard
          cardKey="batteriesLock"
          titleKey={roofKey("CARDS.BATTERIES_LOCK")}
        />
      </CardRow>
    </StructureSection>

    <StructureSection titleKey={roofKey("SECTIONS.ELECTRICAL")}>
      <CardRow columns={3}>
        <AccessoryNoteCard
          cardKey="rearLightMounts"
          titleKey={roofKey("CARDS.REAR_LIGHT_MOUNTS")}
        />
        <AccessoryNoteCard
          cardKey="sideLighting"
          titleKey={roofKey("CARDS.SIDE_LIGHTING")}
        />
        <AccessoryNoteCard
          cardKey="microphoneLights"
          titleKey={roofKey("CARDS.MICROPHONE_LIGHTS")}
        />
      </CardRow>
      <CardRow columns={3}>
        <Box
          sx={{
            gridColumn: "span 2",
            minWidth: 0,
            height: "100%",
            "& > *": { height: "100%" },
          }}
        >
          <AccessoryNoteCard
            cardKey="interiorLighting"
            titleKey={roofKey("CARDS.INTERIOR_LIGHTING")}
          />
        </Box>
        <AccessoryNoteCard
          cardKey="projectors"
          titleKey={roofKey("CARDS.PROJECTORS")}
        />
      </CardRow>
    </StructureSection>
  </>
);

export default AccessoriesLocks;
